import React from 'react'
import ExtendStore from "../../../base/extendStore"
import { observable, action, runInAction } from 'mobx'
import { Stores } from 'src/stores'
import { message } from 'antd'
import {CheckboxChangeEvent} from "antd/lib/checkbox"
import entityUtil from "src/utils/entityUtil"
import iAlbumDetailApi from 'src/apis/iAlbumDetailApi'
import contentMgApi from 'src/apis/contentMgApi'
import { IEntitiesReq, IEntitiesRes ,IGetBreadcrumbRes} from 'src/types/iAlbumDetailTypes'
import { SmartMetadataType } from 'src/stores/iEntity/extends/smartViewStore'
import iSearchTypes from 'src/types/iSearchTypes'
import contentMgTypes from 'src/types/contentMgTypes'
export default class AllTopicStore extends ExtendStore {
    @observable
    public isExpanded: boolean = true  //已展开
    @observable
    public isSearchingTree: boolean = false  //是否正在初始化搜索树
    @observable
    public mode: number = iSearchTypes.DataViewModes.CARD  /** 模式 */
    @observable
    public keyword: string
    @observable
    public status: string = "0"  //状态：所有、上架、下架
    @observable
    public filterType: string = "Eq"  //"Eq"主题 "NOT"素材
    @observable
    public startTime: string
    @observable
    public endTime: string
    @observable
    public currentSort: string = "createDate_:desc"  //desc降序asc升序
    @observable
    public currentPushStatus: string = ""  //推送状态：全部、已推送、未推送
    @observable
    public currentTopic: any //左侧树菜单选中的专题
    @observable
    public breadcrumb: IGetBreadcrumbRes[] //面包屑
    @observable
    public entitiesRes: IEntitiesRes | undefined //专题详情查询结果(包含专题和非专题的)
    @observable
    public page: number = 1
    // @observable
    // public topicPage: number = 1
    // @observable
    // public otherPage: number = 1
    @observable
    public size: number = 20
    public pageSizes: number[] = [20, 50, 100, 200]
    @observable
    public topicDataRes: IEntitiesRes | undefined //专题详情查询结果(包含专题)
    // @observable
    // public otherDataRes: IEntitiesRes | undefined //专题详情查询结果(包含非专题)
    @observable
    public isLoadingTopicEntities = false //是否正在查询专题详情
    // @observable
    // public isLoadingOtherEntities = false //是否正在查询专题详情
    @observable
    public allSelected: boolean = false  //是否全选
    
    public topicTree: any = React.createRef()
    
    public constructor(stores: Stores) {
        super(stores)
        this.initNewCreateAlbumStore(stores)
    }

    @action
    public switchAllSelected(selected: boolean){
        this.allSelected = selected
    }

    @action
    public handleCheckAll = (e: CheckboxChangeEvent) => {
        this.switchAllSelected(e.target.checked);
        this.switchListItemSelected(undefined, e.target.checked)
    }

    @action
    public switchListItemSelected(indexArr: number[] | undefined, selected: boolean, isTopic?: boolean){
        if (indexArr){
            // 行数组
            if (typeof(indexArr) === 'object' && indexArr instanceof Array){
                //if(isTopic){
                    indexArr.map((i: number) => {
                        if(this.topicDataRes && this.topicDataRes.data){
                            this.topicDataRes.data[i].selected = selected
                        }
                    })
                // }else{
                //     indexArr.map((i: number) => {
                //         if(this.otherDataRes && this.otherDataRes.data){
                //             this.otherDataRes.data[i].selected = selected
                //         }
                //     })
                // }
            }
            // 检查是否全选或不全选
            let selectAll = true
            // if(this.topicDataRes || this.otherDataRes){
            //     this.topicDataRes?.data.map((item)=>{
            //         if (!item.selected){
            //             selectAll = false
            //         }
            //     })
            //     this.otherDataRes?.data.map((item)=>{
            //         if (!item.selected){
            //             selectAll = false
            //         }
            //     })
            // }
            if(this.topicDataRes){
                this.topicDataRes?.data.map((item)=>{
                    if (!item.selected){
                        selectAll = false
                    }
                })
            }
            this.switchAllSelected(selectAll)
        }else{ //所有
            if(this.topicDataRes && this.topicDataRes.data){
                this.topicDataRes.data.map((item)=>{
                    item.selected = selected;
                })
            }
            // if(this.otherDataRes && this.otherDataRes.data){
            //     this.otherDataRes.data.map((item)=>{
            //         item.selected = selected;
            //     })
            // }
            this.switchAllSelected(selected);
        }
    }

    @action
    public setCurrentTopic= (currentTopic: any) => {
        this.currentTopic = currentTopic
        if(currentTopic){
            this.getBreadcrumb(currentTopic.contentId)
            this.setPage(1)
            this.setFilterType("Eq")
            this.getEntitys(currentTopic.contentId)
        }else{
            this.breadcrumb = []
            this.topicDataRes = undefined
            // this.otherDataRes = undefined
        }
    }
    @action
    public setFilterType(filterType: string) {
        this.filterType = filterType
    }
    @action
    public setStatus(status: string) {
        this.status = status
    }
    @action
    public setStartTime(startTime: string) {
        this.startTime = startTime
    }
    @action
    public setEndTime(endTime: string) {
        this.endTime = endTime
    }
    @action
    public setCurrentSort(currentSort: string) {
        this.currentSort = currentSort
    }
    @action
    public setCurrentPushStatus(currentPushStatus: string) {
        this.currentPushStatus = currentPushStatus
    }
    @action
    public setMode(mode: number) {
        this.mode = mode
    }
    @action
    public setKeyword(keyword: string) {
        this.keyword = keyword
    }
    @action
    public setIsExpanded(isExpanded: boolean) {
        this.isExpanded = isExpanded
    }
    @action
    public setSize(size: number) {
        this.size = size
        if(this.currentTopic){
            this.getEntitys(this.currentTopic.contentId)
        }
    }
    @action
    public setPage(page: number) {
        this.page = page
    }
    // @action
    // public setTopicPage(topicPage: number) {
    //     this.topicPage = topicPage
    // }
    // @action
    // public setOtherPage(otherPage: number) {
    //     this.otherPage = otherPage
    // }
    @action
    public getSearchTreeParams = (contentId?: string): contentMgTypes.allTopic.ISearchTopicTreeReq => {
        let params: contentMgTypes.allTopic.ISearchTopicTreeReq = {
            pageIndex: 1,
            pageSize: 1000,
            keyword: [],
            facetConditions: [],
            conditions: [
                {
                    field: "type_",
                    value: ["biz_sobey_album"]
                },
                {
                    field: "albumType_",
                    value: ["Manual"]
                },
            ],
            sorts: [
                {
                    field: "createDate_",
                    desc: true
                }
            ],
            keywordSearchType: "fullText"
        }
        if(contentId){
            params.conditions.push({
                field: "album",
                value: [contentId]
            })
        }
        if(this.keyword){
            params.keyword = [this.keyword]
        }
        if(this.startTime && this.endTime){
            params.conditions.push({
                field: "createDate_",
                value: [this.startTime+" 00:00:00 To "+this.endTime+" 23:59:59"]
            })
        }
        return params
    }
    //查询左侧树: 查根节点树
    @action
    public getInitTopicTree = () => {
        this.isSearchingTree = true
        return new Promise((resolve, reject) => {
            contentMgApi.allTopic.getInitTopicTree(this.getSearchTreeParams()).then((res) => {
                runInAction(()=>{
                    if (res.data.data) {
                        this.isSearchingTree = false
                        if(res.data.data.data){
                            res.data.data.data.map((item) => {
                                item.name = item.name_
                                item.duration = item.duration_
                                item.contentId = item.contentId_
                                item.framerate = item.framerate_
                            })
                            resolve(res.data.data.data)
                        }else{
                            resolve([])
                        }
                    }else{
                        reject()
                    }
                })
            }, res => {
                runInAction(()=>{
                    if (res.data.error && res.data.error.title) {
                        message.error(res.data.error.title)
                    }
                    this.isSearchingTree = false
                    reject()
                })
            })
        })
    }
    //查询左侧树: 不传contentId查全部（根节点+子节点），传contentId查子节点树
    @action
    public getTopicTreeNode = (contentId: string) => {
        return new Promise((resolve, reject) => {
            contentMgApi.allTopic.getTopicTreeNode(this.getSearchTreeParams(contentId)).then((res) => {
                runInAction(()=>{
                    if (res.data.data) {
                        if(res.data.data.data){
                            res.data.data.data.map((item) => {
                                item.name = item.name_
                                item.duration = item.duration_
                                item.contentId = item.contentId_
                                item.framerate = item.framerate_
                                //赋值父节点值
                                item.parentcontentid = contentId
                            })
                            resolve(res.data.data.data)
                        }else{
                            resolve([])
                        }
                    }else{
                        reject()
                    }
                })
            }, res => {
                runInAction(()=>{
                    if (res.data.error && res.data.error.title) {
                        message.error(res.data.error.title)
                    }
                    reject()
                })
            })
        })
    }
    //查询专题详情
    @action
    public getEntitys(contentId: string){
        this.getTopicEntitys(contentId)
        // this.getOtherEntitys(contentId)
    }
    @action
    public getTopicEntitys(contentId: string){
        let params: IEntitiesReq = {
            // pageIndex: this.topicPage,
            pageIndex: this.page,
            pageSize: this.size,
            keyword: [],
            contentId,
            sorts:[
                {
                    field: this.currentSort.split(":")[0],
                    desc: this.currentSort.split(":")[1] === "desc",
                }
            ],
            conditions: [
                {
                    field: "type_",
                    value: ["biz_sobey_album"],
                    nexus: this.filterType,
                }
            ],
        }
        
        this.isLoadingTopicEntities = true
        this.topicDataRes = undefined
        return new Promise((resolve, reject) => {
            iAlbumDetailApi.queryEntities(params).then(res=>{
                runInAction(()=>{
                    if (res.data.data){
                        if(res.data.data.data){
                            res.data.data.data.map((item)=>{
                                item.name = item.name_
                                item.duration = item.duration_
                                item.contentId = item.contentId_
                                item.framerate = item.framerate_
                            })
                        }
                        this.topicDataRes = res.data.data
                        this.isLoadingTopicEntities = false
                        resolve(true)
                    }else{
                        reject()
                    }
                })
            }, res=>{
                runInAction(()=>{
                    if (res.data.error && res.data.error.title){
                        message.error(res.data.error.title)
                    }
                    this.isLoadingTopicEntities = false
                    reject()
                })
            })
        })
    }
    // @action
    // public getOtherEntitys(contentId: string){
    //     let params: IEntitiesReq = {
    //         pageIndex: this.otherPage,
    //         pageSize: this.size,
    //         keyword: [],
    //         contentId,
    //         sorts:[
    //             {
    //                 field: this.currentSort.split(":")[0],
    //                 desc: this.currentSort.split(":")[1] === "desc",
    //             }
    //         ],
    //         conditions: [
    //             {
    //                 field: "type_",
    //                 value: ["biz_sobey_album"],
    //                 nexus: 'NOT',
    //             }
    //         ],
    //     }
    //     this.isLoadingOtherEntities = true
    //     this.otherDataRes = undefined
    //     return new Promise((resolve, reject) => {
    //         iAlbumDetailApi.queryEntities(params).then(res=>{
    //             runInAction(()=>{
    //                 if (res.data.data){
    //                     if(res.data.data.data){
    //                         res.data.data.data.map((item)=>{
    //                             item.name = item.name_
    //                             item.duration = item.duration_
    //                             item.contentId = item.contentId_
    //                             item.framerate = item.framerate_
    //                         })
    //                     }
    //                     this.otherDataRes = res.data.data
    //                     this.isLoadingOtherEntities = false
    //                     resolve(true)
    //                 }else{
    //                     reject()
    //                 }
    //             })
    //         }, res=>{
    //             runInAction(()=>{
    //                 if (res.data.error && res.data.error.title){
    //                     message.error(res.data.error.title)
    //                 }
    //                 this.isLoadingOtherEntities = false
    //                 reject()
    //             })
    //         })
    //     })
    // }
    //查询面包屑
    @action
    public getBreadcrumb(contentId:string){
        return new Promise((resolve, reject) => {
            iAlbumDetailApi.getBreadcrumb(contentId).then((res) => {
                runInAction(() => {
                    if (res.data.data) {
                        this.breadcrumb = res.data.data
                        resolve(true)
                    }else{
                        reject()
                    }
                })
            }, res=>{
                if (res.data.error && res.data.error.title){
                    message.error(res.data.error.title);
                }
                reject()
            })
        })
    }

    public toEditDetail = (item: any, isEdit?: boolean) => {
        if (item.type !== 'folder') {
            let href: string = ''
            if (item.type === 'dataset' && this.stores.userStore.currentUser) {//资料集
                href = `/iHome/datasetDetails/${item.contentId}/${encodeURIComponent(item.name)}`
            } else if (item.type === 'album' && this.stores.userStore.currentUser) {
                href = `/iHome/iAlbumDetail/${item.contentId}/${item.site_ || this.stores.userStore.currentUser.siteCode}`+ (isEdit ? `?isEdit=${isEdit}`:``)       
            }else {
                href = entityUtil.getViewEntityUrl(item, isEdit ? entityUtil.ViewEntityType.EDIT : entityUtil.ViewEntityType.BROWSE)
            }
            if (item.type === SmartMetadataType.story || item.type === SmartMetadataType.scene
                || item.type === SmartMetadataType.shot) {
                href = entityUtil.getEntityPartUrl(item)
            }
            window.open(href)
        }

    }
    
}
